<template>
	<b-modal class="modal-lg" size="lg" id="ModalSendLoginDetails" ref="sendLoginDetails-modal" :title="sendLoginDetailsModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetModal('main')">
		<template slot="modal-header" slot-scope="{ close }">
			<h5 class="modal-title text-light">{{ sendLoginDetailsModal.modalData.title }}</h5>
			<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
		</template>
		<template slot="default">
			<div class="row modal-body-log">
				<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
					<b-input-group v-if="sendLoginDetailsModal.modalData.component == 'customerUsers'" class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('sendToLabelText', 'sendToLabelText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-select v-model="sendLoginDetailsModal.modalData.selectedEmail" :options="sendLoginDetailsModal.modalData.emails" value-field="email" text-field="email"></b-form-select>
					</b-input-group>					
					<b-input-group v-else class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('sendToLabelText', 'sendToLabelText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-input id="real_name" v-model="sendLoginDetailsModal.modalData.email"></b-form-input>
					</b-input-group>
					<b-input-group class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('subjectLabelText', 'subjectLabelText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-input id="email_address" v-model="sendLoginDetailsModal.modalData.subject"></b-form-input>
					</b-input-group>
					<b-input-group class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('fromLabelText', 'fromLabelText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-input id="user_password" v-model="sendLoginDetailsModal.modalData.from" ></b-form-input>
					</b-input-group>
					<b-input-group class="py-2">
						<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
							<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('messageLabelText', 'messageLabelText') }}</span></b-input-group-text>
						</b-input-group-prepend>
						<b-form-textarea id="email-to" v-model="sendLoginDetailsModal.modalData.message" class="form-control" rows="5" max-rows="5" required>
						</b-form-textarea>
					</b-input-group>																																				
				</b-form-group>
        <div class="col-12 px-2 py-2">
          <div class="col-12 legend-div py-2">
            <div class="col-12">
              <h5>{{ t('modalSendLoginDetailsLegendLabel', 'modalSendLoginDetailsLegendLabel') }}</h5>
            </div>
            <div class="col-12">
              <span>{{ t('sendLoginDetailsUsernamePlaceholderDesc', 'sendLoginDetailsUsernamePlaceholderDesc') }}</span>
            </div>
            <div class="col-12">
              <span>{{ t('sendLoginDetailsPasswordPlaceholderDesc', 'sendLoginDetailsPasswordPlaceholderDesc') }}</span>
            </div>
            <div class="col-12">
              <span>{{ t('sendLoginDetailsClientNamePlaceholderDesc', 'sendLoginDetailsClientNamePlaceholderDesc') }}</span>
            </div>          
            <div class="col-12">
              <span>{{ t('sendLoginDetailsBaseHrefPlaceholderDesc', 'sendLoginDetailsBaseHrefPlaceholderDesc') }}</span>
            </div>
			<div class="col-12">
              <span>{{ t('sendLoginDetailsCustRefPlaceholderDesc', 'sendLoginDetailsCustRefPlaceholderDesc') }}</span>
            </div>
            <!-- [PASSWORD], [USERNAME], [CLIENT_NAME], [BASE_HREF], [CUSTOMER_REFERENCE] --> 
          </div>
        </div>
			</div>
		</template>
		<template slot="modal-footer" slot-scope="{ close }">
			<button type="button" class="btn btn-secondary" @click="close()">{{ t('cancelText', 'cancelText') }}</button>
			<button v-if="!buttonIsBusy" type="button" class="btn btn-primary" :disabled="!sendLoginDetailsModal.modalData.email && !sendLoginDetailsModal.modalData.selectedEmail" @click="sendEmail()">{{ t('sendEmailText', 'sendEmailText') }}</button>							
			<b-button v-else variant="primary" disabled>
				<b-spinner small type="grow"></b-spinner>
				{{ t('sendEmailText', 'sendEmailText') }}
			</b-button>			
		</template>
		<ValidationErrors class="p-1" v-if="getValidationErrors.validationName == 'endUserError'"></ValidationErrors>			
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalSendLoginDetails',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal'
  ],
  components:{
    ResponseInfo
  },
  data () {
    return {
      sendLoginDetailsModal: {},
			buttonIsBusy: false,
			emailModal: {}
    }
	},
  computed:{
    ...mapGetters(['getResponseInfo', 'getValidationErrors'])
  },
  methods:{
    fetchAdditionalInfo() {
      //clear previous response
      this.$store.dispatch('alertClearResponse')
		},
		sendEmail() {
			this.buttonIsBusy = true
			if(this.sendLoginDetailsModal.modalData.component == 'customerUsers') {
				this.$store.dispatch('manageCustomersStore/sendEmailToCustomerUser', {
					sendTo: this.sendLoginDetailsModal.modalData.selectedEmail,
					from: this.sendLoginDetailsModal.modalData.from,
					subject: this.sendLoginDetailsModal.modalData.subject,
					message: this.sendLoginDetailsModal.modalData.message,
					customerId: this.sendLoginDetailsModal.modalData.custId
				}).then(() => {
					this.buttonIsBusy = false
					if(this.getValidationErrors.userEmail == undefined){
						this.$refs['sendLoginDetails-modal'].hide()
					}
				})
			} else {
				this.$store.dispatch('endUsersAdminLogonsStore/sendEmailToUser', {
					userId: this.sendLoginDetailsModal.modalData.userId,
					sendTo: this.sendLoginDetailsModal.modalData.email,
					from: this.sendLoginDetailsModal.modalData.from,
					subject: this.sendLoginDetailsModal.modalData.subject,
					password: this.sendLoginDetailsModal.modalData.password,
					message: this.sendLoginDetailsModal.modalData.message,
					component: this.sendLoginDetailsModal.modalData.component
				}).then(() => {
					this.buttonIsBusy = false
					if(this.getValidationErrors.userEmail == undefined){
						this.$refs['sendLoginDetails-modal'].hide()
					}
				})	
			}
		
		},
  },
  created() {
		this.sendLoginDetailsModal = this.$attrs.modal
  },
}
</script>

<style scoped>
  .legend-div {
    border: 1px solid #ccc;
  }
</style>
